<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/products/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";

export default {
  mixins: [UpdateForm],
  components: {App, Form},
  props: ['product_id', 'cancel_url'],
  data() {
    return {
      formRoute: route('api.v1.products.update', {product: this.product_id}),
      redirectRoute: '',
    }
  },
  methods: {
    afterSuccess(form, response) {
      this.getProduct();
    },

    getProduct() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.products.show', {'product': this.product_id}),
        success: (response) => {
          this.$refs.form.setProduct(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getProduct();
    this.redirectRoute = this.cancel_url;
  }
}
</script>

<template>
  <App title="Product bewerken">
    <form id="productForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="productForm"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>